import { Injectable } from '@angular/core';

@Injectable()
export class GlobalService {

  private MainData;
  private HospitalInfo;
  private DoctorInfo;
  private SlecetdSolts;
  private AppointmentResponce;
  private bookAppointmentData;
  constructor() { }
  setData(val) {
    this.MainData = val;
  }
  getData() {
    return this.MainData;
  }
  setHospitalInfo(val) {
    this.HospitalInfo = val;
  }
  getHospitalInfo() {
    return this.HospitalInfo;
  }

  setDoctorInfo(val) {
    this.DoctorInfo = val;
  }
  getDoctorInfo() {
    return this.DoctorInfo;
  }
  setSlecetdSolts(val) {
    this.SlecetdSolts = val;
  }
  getSlecetdSolts() {
    return this.SlecetdSolts;
  }

  setAppointmentResponce(val) {
    this.AppointmentResponce = val;
  }
  getAppointmentResponce() {
    return this.AppointmentResponce;
  }

  setbookAppointmentData(val) {
    this.bookAppointmentData = val;
  }
  getbookAppointmentData() {
    return this.bookAppointmentData;
  }

}



// WEBPACK FOOTER //
// ./src/app/global.service.ts